import React from "react";
import "../styles/FiscalSponsorship.css";
import { FaRocket } from "react-icons/fa";
import { GiPayMoney, GiSurroundedShield } from "react-icons/gi";

const IconBadge = ({ children, label }) => (
  <div className="fs__icon-badge" aria-hidden="true">
    {children}
    <span className="fs__sr-only">{label}</span>
  </div>
);

const FiscalSponsorship = () => {
  const features = [
    {
      icon: <FaRocket />,
      label: "Launch Faster icon",
      title: "Launch Faster",
      description:
        "Move forward in weeks—not the 9–12+ months it can take to form a standalone nonprofit. Fiscal sponsorship allows projects to begin operating under an established 501(c)(3) immediately, enabling fundraising and program activity to start much sooner.",
    },
    {
      icon: <GiPayMoney />,
      label: "Lower Cost icon",
      title: "Lower Cost, Less Administrative Burden",
      description:
        "Starting and maintaining an independent nonprofit can require significant time, cost, and administrative effort. Fiscal sponsorship provides the operational infrastructure needed to move forward without taking on the full burden of standalone nonprofit administration.",
    },
    {
      icon: <GiSurroundedShield />,
      label: "Protected and Supported icon",
      title: "Supported with Strong Oversight",
      description:
        "A strong fiscal sponsor provides the structure, stewardship, and administrative support needed to help charitable work operate responsibly. From financial oversight and reporting to compliance-minded operations, fiscal sponsorship creates a solid foundation for projects to grow.",
    },
  ];

  return (
    <section className="fiscal-sponsorship">
      <div className="fs__container">
        <header className="fs__header">
          <h2>What is Fiscal Sponsorship?</h2>
          <p className="fs__intro">
            Fiscal sponsorship is a practical way for charitable initiatives to
            operate under an established nonprofit structure, allowing projects
            to focus on mission and momentum without the burden of building and
            maintaining a separate nonprofit organization from scratch.
          </p>
        </header>

        <div className="fs__grid">
          {features.map(({ icon, title, description, label }, i) => (
            <article key={i} className="fs__card">
              <IconBadge label={label}>{icon}</IconBadge>
              <h3 className="fs__card-title">{title}</h3>
              <p className="fs__card-body">{description}</p>
            </article>
          ))}
        </div>

        {/* Optional CTA block — keep or remove as needed */}
        {/* <div className="fs__cta">
          <h3>Ready to get started?</h3>
          <p>Learn whether fiscal sponsorship is the right fit for your project.</p>
          <div className="fs__cta-actions">
            <a className="fs__btn fs__btn--primary" href="/apply">Apply Now</a>
            <a className="fs__btn fs__btn--secondary" href="/guidelines">View Guidelines</a>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default FiscalSponsorship;